import { render, staticRenderFns } from "./CreateTenantChargersAssignment.vue?vue&type=template&id=3c9239b6"
import script from "./CreateTenantChargersAssignment.vue?vue&type=script&lang=js"
export * from "./CreateTenantChargersAssignment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports